import { groupBy, isEqual } from 'lodash-es'
import moment from 'moment-timezone'

export const filterActiveRules = (rules, timezone) => rules.filter(({ date }) => {
  const localToday = moment.tz(timezone)
  const localRuleDate = moment.tz(date, timezone)
  return localRuleDate.isSameOrAfter(localToday.startOf('day'))
})

const groupByIntervals = (rules) => rules.reduce((acc, { date, intervals }) => {
  const previousRange = acc.pop()

  if (!previousRange) {
    return [...acc, { dates: [date], intervals }]
  }

  const lastDate = moment(previousRange.dates[previousRange.dates.length - 1])
  const isSameYear = lastDate.year() === moment(date).year()
  const isNextDay = lastDate.add(1, 'days').format('YYYY-MM-DD') === date
  const hasSameIntervals = isEqual(previousRange.intervals, intervals)

  if (!isSameYear || !isNextDay || !hasSameIntervals) {
    return [...acc, previousRange, { dates: [date], intervals }]
  }

  return [...acc, {
    ...previousRange,
    dates: [...previousRange.dates, date]
  }]
}, [])

export const getRules = (dates) => {
  const activeRules = filterActiveRules(dates)

  return groupByIntervals(activeRules)
}

export const groupByYear = (rules) => Object.entries(
  groupBy(rules, ({ dates }) => moment(dates[0]).year())
)
